import type {
	AppConfig,
	Cart,
	DeepPartial,
	NubeSDKState,
} from "@tiendanube/nube-sdk-types";
import type { AppUI, GlobalUI } from "./ui-extensions";

export type AppID = string;

export type AppError = { code: string; message?: string } | string;

export type AppState = {
	id: AppID;
	script: string;
	config?: AppConfig;
	registered?: boolean;
	cart?: Pick<Cart, "validation">;
	errors?: AppError[];
	ui?: AppUI;
};

export type NubeSDKRuntimeState = Omit<NubeSDKState, "ui"> & {
	ui: GlobalUI;
} & DeepPartial<{
		apps: Record<AppID, AppState>;
	}>;

export const WORKER_PRIVATE_STATE_PATHS = ["ui.slots", "config"];
